import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { dbEnums } from "@/types/enums/dbEnums";
import { DraftJobSeekerDto } from "@api/draft-job-seeker-dto";
import { PropType, computed } from "vue";
import { PersonFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import LanguageSkillsField from "@/components/LanguageSkillsField.vue";
import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import OccupationalCompetenceSelect from "@/components/OccupationalCompetenceSelect.vue";
import { useValidateProps } from "@/composables/fields";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSeekerFormSkillsFields',
  props: {
	fieldsMap: {
		type: Object as PropType<PersonFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftJobSeekerDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const fields = dbEnums.PersonFields;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("jobSeekerForm.sectionHeaders.skillsInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.JobSeekerExperienceAndSkills)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.JobSeekerExperienceAndSkills.fields
            }, {
              [_unref(fields).JobSeekerSearchProfessions]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.searchProfessions"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid }) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueMulti: formDataComputed.value.searchProfessions,
                      "onUpdate:valueMulti": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.searchProfessions) = $event)),
                      infoTable: "SearchProfessions",
                      translationsTable: "SearchProfessionTranslations",
                      translationProperty: "name",
                      ajax: false,
                      tree: "",
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["valueMulti", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerLanguageSkills]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.languageSkills"
                }, {
                  default: _withCtx(() => [
                    _createVNode(LanguageSkillsField, {
                      modelValue: formDataComputed.value.languageSkills,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.languageSkills) = $event)),
                      propertyPath: "draftJobSeekerData.languageSkills"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerLanguageSkillsDescription]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.languageSkillsDescription"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.languageSkillsDescription,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.languageSkillsDescription) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerDrivingLicenseClasses]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.driverLicenseClasses"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid }) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueMulti: formDataComputed.value.driverLicenseClasses,
                      "onUpdate:valueMulti": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.driverLicenseClasses) = $event)),
                      infoTable: "DriverLicenseClasses",
                      translationsTable: "DriverLicenseClassTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["valueMulti", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerOwnsCar]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.ownsCar",
                  "align-content": ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoCheckbox, {
                      modelValue: formDataComputed.value.ownsCar,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.ownsCar) = $event)),
                      for: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "for", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerDrivingLicenseOccupationalCompetence]: _withCtx(({ field }) => [
                (formDataComputed.value.driverLicenseClasses.length > 0)
                  ? (_openBlock(), _createBlock(Field, {
                      key: 0,
                      field: field,
                      propertyPath: "driverLicenseOccupationalCompetence",
                      infoidentifier: "personJobSeekerData.driverLicenseOccupationalCompetence"
                    }, {
                      default: _withCtx(({ isInvalid }) => [
                        _createVNode(OccupationalCompetenceSelect, {
                          valueMulti: formDataComputed.value.driverLicenseOccupationalCompetences,
                          "onUpdate:valueMulti": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.driverLicenseOccupationalCompetences) = $event)),
                          type: "DrivingLicense",
                          options: formDataComputed.value.driverLicenseClasses,
                          isInvalid: isInvalid
                        }, null, 8, ["valueMulti", "options", "isInvalid"])
                      ]),
                      _: 2
                    }, 1032, ["field"]))
                  : _createCommentVNode("", true)
              ]),
              [_unref(fields).JobSeekerITSkills]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.itSkills"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid }) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueMulti: formDataComputed.value.itSkills,
                      "onUpdate:valueMulti": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.itSkills) = $event)),
                      infoTable: "ITSkills",
                      translationsTable: "ITSkillTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["valueMulti", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerITSkillsDescription]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.itSkillsDescription"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.itSkillsDescription,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.itSkillsDescription) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerHobbies]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.hobbies"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.hobbies,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.hobbies) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})